<template>
    <v-app-bar v-if="isMain" class="pl-8 pr-4 py-5 transparent-navbar" flat>
        <v-spacer />
        <language-buttton variant="text" />
    </v-app-bar>

    <v-app-bar v-else class="pl-8 pr-4 py-5 bg-color" flat>
        <home-button/>
        <v-spacer />
        <language-buttton variant="text" />
    </v-app-bar>

</template>

<script>
import LanguageButtton from './LanguageButton.vue'
import HomeButton from './HomeButton.vue';

export default {
    name: 'NavBar',
    props: {
        isMain : {
            type: Boolean,
            default: true
        }
    },
    components: {
        LanguageButtton,
        HomeButton
    }
}
</script>


<style scoped>
.transparent-navbar {
  background-color: transparent !important;
  box-shadow: none !important;
}
.bg-color {
    background-color: rgba(242, 242, 247, 1)    ;
}
</style>
